export const coverageFromDto = (dto) => ({
  id: dto.id,
  code: dto.code,
  name: dto.name,
  coverageType: dto.coverage_type, // main | assistance | other
});

export const coverageConfigFromDto = (dto) => ({
  id: dto.id,
  agreementPlanId: dto.agreement_plan,
  coverage: coverageFromDto(dto.coverage),
  limit: dto.limit,
  limitIsInsuredValue: dto.limit_is_insured_value,
  deductible: dto.deductible,
  active: dto.active,
});

export const coverageConfigCreateToDto = (data) => ({
  agreement_plan: data.agreementPlanId,
  coverage: data.coverageId,
  limit: data.limit,
  limit_is_insured_value: data.limitIsInsuredValue,
  deductible: data.deductible,
});

export const coverageConfigUpdateToDto = (data) => ({
  coverage: data.coverageId,
  limit: data.limit,
  limit_is_insured_value: data.limitIsInsuredValue,
  deductible: data.deductible,
});
